import {Box, Button} from "@mui/material";
import React, {useEffect, useState} from "react";
import DetailService from "../../../../../API/orders/cutting/detail/DetailService";
import DetailCompositionController from "../../../../../API/organization/DetailCompositionController";
import DetailTable from "../../../../../components/UI/table/cutting/details/DetailTable";
import {useLocation, useParams} from "react-router-dom";
import DetailUtil from "../../../../../utils/cutting/DetailUtil";
import Typography from "@mui/material/Typography";
import {BreadcrumbsComponent} from "../../../../../components/UI/breadcrumb/BreadcrumbComponent";
import {constantsErrorMessages} from "../../../../../Constants";
import ModalAlert from "../../../../../components/UI/table/customer-detales/ModalAlert";
import {EditLocalStoragePagesData} from "../../../../../utils/EditLocalStoragePagesData";
import CheckIcon from "@mui/icons-material/Check";
import {ButtonGroupTabBar} from "../../../../../components/UI/button/ButtonGroupTabBar";
import UploadFilesRequestsForm from "../../../orders/estimate/UploadFilesRequestsForm";
import FileService from "../../../../../API/orders/orders/customer/FileService";
import FileUploadController from "../../../../../API/organization/FileUploadController";
import ExportDetail from "../../../../customer/processing/ExportDetail";
import {withFilter} from "../../../../../data/FilterTables/withFilterHOC";
import {DetailFilterData} from "../../../../../data/FilterTables/DetailFilterData";

const getDetailsByRequestsCuttingApi = (cloudParam) => {
    if (cloudParam === "composition") {
        return (requestsCuttingId, orderId) =>
            DetailCompositionController.forRequestsCutting(requestsCuttingId, orderId);
    }
    if (cloudParam) {
        return (requestsCuttingId) => DetailService.getAllByRequestsCuttingIdByCloud(requestsCuttingId);
    }
    return (requestsCuttingId) => DetailService.getAllByRequestsCuttingId(requestsCuttingId);
};

const imports = [
    {
        id: 1,
        helpText: "Импорт деталей из файла(базис раскроя)",
        multiple: true,
        upload: FileUploadController.uploadRequestsCuttingFiles
    },
    {
        id: 2,
        helpText: "Импорт деталей из файла (Pro100 раскроя)",
        multiple: false,
        upload: FileUploadController.uploadRequestsCuttingFilesPro100
    },
]
const ComponentDetailWithFilter = withFilter(DetailTable, DetailFilterData);

const DetailsRequestsCutting = () => {
    const location = useLocation()
    const pathname = location.pathname
    const searchParams = new URLSearchParams(location.search)
    const [data, setData] = useState([]);
    const [isError, setIsError] = useState(false);
    const [unableCut, setUnableCut] = useState({});
    const [unableTurn, setUnableTurn] = useState({});
    const [selectedIds, setSelectedIds] = useState([]);
    const [modalStatusOpen, setModalStatusOpen] = useState(false);
    const [status, setStatus] = useState(true);
    const [typeStatus, setTypeStatus] = useState(null);
    const [change, setChange] = useState(false);
    const [alertData, setAlertData] = useState({});
    const [tab, setTab] = useState(1);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const handleChange = (event, newValue) => {
        setTab(newValue);
        EditLocalStoragePagesData(pathname, "tab", newValue)
    };
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`${pathname}`, "pageSize", nextState.pageSize)
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`${pathname}`]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
        const savedTab = pagesData[pathname]?.tab
        savedTab && setTab(savedTab)
    }
    const params = useParams();

    const requestsCuttingId = params.id;
    const numberRequestsCutting = params.numberRequestsCutting;
    // orderId: новый query-параметр; compositionId — fallback для старых ссылок
    const orderId = searchParams.get("orderId") ?? searchParams.get("compositionId");

    useEffect(() => {
        getStartPageSize()
        const api = getDetailsByRequestsCuttingApi(params.cloud)
        if (params.cloud === "composition" && (orderId == null || orderId === "")) {
            handleModalAlert("Не удалось определить заказ");
            return;
        }
        api(requestsCuttingId, orderId).then(function (response) {
            let data = response.data;
            const error = DetailUtil.checkDuplicatePositions(data, false);
            if (error.length > 0) {
                setIsError(true);
            }
            setData(data);
            setTableOptions((prev) => ({...prev, totalElements: data?.length}))
            data.forEach((row) => {
                unableCut[row.id] = row.cut;
                unableTurn[row.id] = row.turn;
            });
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, [change]);

    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }

    const isComposition = params.cloud === "composition";
    const breadcrumbPath = isComposition
        ? [
            {name: "Главная", href: "/"},
            {name: "Композиции", href: "/organization/orders-composition"},
        ]
        : [
            {name: "Главная", href: "/"},
            {name: "Заказы", href: "/organization/orders"},
            {name: "Заявки на раскрой", href: "/organization/requests-cutting"},
        ];

    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={`Детали на раскрой заявки ${numberRequestsCutting}`}
                path={breadcrumbPath}/>

            <Typography sx={{fontSize: "24px", fontWeight: 700, paddingBottom: "30px"}}>
                Детали на раскрой заявки {numberRequestsCutting}
            </Typography>
            <ButtonGroupTabBar activeTab={tab}>
                <Button tabIndex={1} onClick={(e) => handleChange(e, 1)}>
                    <CheckIcon/>
                    Детали
                </Button>
                <Button tabIndex={2} onClick={(e) => handleChange(e, 2)}>
                    <CheckIcon/>
                    Импорт
                </Button>
                <Button tabIndex={3} onClick={(e) => handleChange(e, 3)}>
                    <CheckIcon/>
                    Экспорт
                </Button>
            </ButtonGroupTabBar>
            {tab === 1 ? <ComponentDetailWithFilter
                data={data}
                setData={setData}
                isError={isError}
                unableCut={unableCut}
                unableTurn={unableTurn}
                setUnableCut={setUnableCut}
                setUnableTurn={setUnableTurn}
                selectedIds={selectedIds}
                setSelectedIds={setSelectedIds}
                modalStatusOpen={modalStatusOpen}
                setModalStatusOpen={setModalStatusOpen}
                status={status}
                setStatus={setStatus}
                typeStatus={typeStatus}
                setTypeStatus={setTypeStatus}
                isColumnMaterial={false}
                isColumnOrder={false}
                warehouse={'orders'}
                enableGrouping={false}
                columnGrouping={[]}
                expanded={false}
                requestsCuttingId={requestsCuttingId}
                change={change}
                setChange={setChange}
                handleModalAlert={handleModalAlert}
                tableOptions={tableOptions}
                tableOptionsHandle={tableOptionsHandle}
                params={params}
            /> : tab === 2 ? <Box sx={{paddingTop: "30px"}}>{imports.map(el => {
                return <UploadFilesRequestsForm
                    key={el.id}
                    uploadData={el}
                    detail={true}
                    // orderId={orderId}
                    change={change}
                    setChange={setChange}
                    calculationRequestsCutting={requestsCuttingId}
                    upload={el.upload}
                    multiple={el.multiple}
                    handleModalAlert={handleModalAlert}
                />
            })}
            </Box> : <Box sx={{paddingTop: "30px"}}>
                <ExportDetail
                    requestsCuttingId={requestsCuttingId}
                    organization={true}
                    all={true}
                    handleModalAlert={handleModalAlert}>
                </ExportDetail>
            </Box>}
            <ModalAlert
                data={alertData}
                onClose={() => setAlertData((alert) => ({...alert, open: false}))}
            />
        </Box>
    );
};

export default DetailsRequestsCutting;